import { NgIf } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { YoungAdultsInfo, YoungAdultsPriceList } from '../../models';
import { Company, CompanyEnum } from '../../models/company.model';
import { JuniorCampAgesPipe } from '../../pipes/junior-camp-ages.pipe';
import { JuniorCampsSchoolDescriptionPipe } from '../../pipes/junior-camps-school-description.pipe';
import { SchoolHeaderComponent } from '../school-header/school-header.component';
import { SubjectEnum } from '../../utils/notes.utils';

@Component({
  standalone: true,
  selector: 'lx-price-lists-portal-young-adults-header',
  imports: [SchoolHeaderComponent, NgIf, JuniorCampAgesPipe, JuniorCampsSchoolDescriptionPipe],
  templateUrl: './young-adults-header.component.html',
  styleUrls: ['./young-adults-header.component.scss'],
})
export class YoungAdultsHeaderComponent implements OnInit {
  @Input() company: Company = CompanyEnum.KIL;
  @Input() applicationForms = [];
  @Input() youngAdultsSchool: YoungAdultsPriceList | undefined;
  protected includedInPackageNote: string | undefined;
  protected youngAdultsSchoolInfo: YoungAdultsInfo | undefined;

  ngOnInit(): void {
    this.youngAdultsSchoolInfo = this.youngAdultsSchool?.youngAdultSchoolInfo;
    const note = this.youngAdultsSchool?.notes?.find((note) => note?.subject === SubjectEnum.YOUNG_ADULTS_INCLUDED_IN_PACKAGE)?.text;
    if (note) {
      this.includedInPackageNote = `Included in the package: ${note}`;
    }
  }
}
